import { render, staticRenderFns } from "./RollGameWin.vue?vue&type=template&id=24bfeb3a&scoped=true"
import script from "./RollGameWin.vue?vue&type=script&lang=js"
export * from "./RollGameWin.vue?vue&type=script&lang=js"
import style0 from "./RollGameWin.vue?vue&type=style&index=0&id=24bfeb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfeb3a",
  null
  
)

export default component.exports